type ProgressCallback = (transferredBytes: number) => void;

export function trackStreamProgress(
  source: ReadableStream<Uint8Array>,
  onProgress: ProgressCallback
): ReadableStream<Uint8Array> {
  const reader = source.getReader();
  let transferred = 0;

  return new ReadableStream<Uint8Array>({
    async pull(controller) {
      const { value, done } = await reader.read();
      if (done) {
        controller.close();
        return;
      }

      transferred += value.byteLength;
      onProgress(transferred);
      controller.enqueue(value);
    },
    cancel(reason) {
      reader.cancel(reason).catch(() => {
        /* swallow */
      });
    }
  });
}
